





import {Component, Vue} from 'vue-property-decorator';

@Component({
    props: ['button_name', 'button_text']
})
export default class GraphButton extends Vue {
    press(event) {
        const selected_graph = event.target.getAttribute('data-graph');
        this.$store.dispatch('press', selected_graph)
    }

}
